export const texts = {
  potentialAnalysis: {
    de: 'Potenzialanalyse',
    en: 'Potential analysis'
  },
  requirements: {
    de: 'Anforderungen',
    en: 'Requirements'
  },
  bookConsultation: {
    de: 'Kostenlose Beratung buchen',
    en: 'Book a free consultation'
  },
  matchingProfiles: {
    de: 'passende Profile',
    en: 'matching profiles'
  },
  perfectMatchesLegend: {
    de: 'Perfect Matches:',
    en: 'Perfect Matches:'
  },
  additionalPotentialLegend: {
    de: 'Zusatzpotenzial:',
    en: 'Additional potential:'
  },
  perfectMatches: {
    de: 'Exakte Matches',
    en: 'Exact Matches'
  },
  idealProfiles: {
    de: 'Ideale Profile',
    en: 'Ideal profiles'
  },
  hiddenTalents: {
    de: 'Hidden Talents',
    en: 'Hidden Talents'
  },
  onlyAtSkillconomy: {
    de: 'Nur bei skillconomy',
    en: 'Only at skillconomy'
  },
  additionalPotential: {
    de: 'Zusatzpotenzial',
    en: 'Additional potential'
  },
  withAdjustments: {
    de: 'Mit Anpassungen',
    en: 'With adjustments'
  },
  reachQuestion: {
    de: 'Wo erreichst du passende Talente?',
    en: 'Where do you reach suitable talents?'
  },
  reachBodyBefore: {
    de: 'Wir haben für dich ausgewertet, über welchen Kanal du passende Talente erreichen kannst. Durch das kontextbasierte Matching von skillconomy findest du für diese Position',
    en: 'We have analyzed which channel lets you reach suitable talents. Thanks to skillconomy’s context-based matching, for this position you find'
  },
  reachBodyAfter: {
    de: 'mehr Talente als mit der manuellen Suche bei LinkedIn, XING & Co.',
    en: 'more talents than with manual search on LinkedIn, XING & co.'
  },
  scMatching: {
    de: 'KI-Kontext-Matching in allen relevanten Netzwerken',
    en: 'AI context matching across all relevant networks'
  },
  booleanSearch: {
    de: 'Boolean Search, kein Kontextwissen',
    en: 'Boolean search, no contextual knowledge'
  },
  jobBoards: {
    de: 'Stellenportale',
    en: 'Job boards'
  },
  activelySearching: {
    de: 'Aktiv suchende Talente',
    en: 'Actively searching talents'
  },
  talentsLabel: {
    de: 'Talente',
    en: 'Talents'
  },
  startSourcing: {
    de: 'Sourcing starten',
    en: 'Start sourcing'
  },
  reachHeadline: {
    de: 'skillconomy erreicht 4x mehr Talente als jede Stellenanzeige',
    en: 'skillconomy reaches 4x more talents than any job ad'
  },
  reachHeadlineBody: {
    de: 'Die besten Kandidaten sind nicht aktiv auf Jobsuche, sondern müssen gefunden werden. Mit skillconomy erreichst du auch alle latent wechselwilligen Talente, die perfekt auf deine Stelle passen.',
    en: 'The best candidates are not actively job hunting – they have to be found. With skillconomy you also reach all passively open talents that are a perfect fit for your position.'
  },
  employersQuestion: {
    de: 'Wo arbeiten passende Talente?',
    en: 'Where do suitable talents work?'
  },
  employersBody: {
    de: 'Die häufigsten aktuellen Arbeitgeber passender Talente – mit Arbeitgeberbewertung im Vergleich zum Branchenschnitt und aktuellem Bewertungstrend.',
    en: 'The most common current employers of suitable talents – with employer rating compared to the industry average and current rating trend.'
  },
  moreCandidatesQuestion: {
    de: 'Wie erreichst du noch mehr Kandidaten?',
    en: 'How can you reach even more candidates?'
  },
  moreCandidatesBody: {
    de: 'Jede Must-have-Skill-Anforderung verringert die Zahl der ansprechbaren Kandidaten. Unten siehst du, wie viele Kandidaten zusätzlich erreichbar wären, wenn die Anforderungen gelockert und die Skills erst nach der Einstellung aufgebaut würden.',
    en: 'Every must-have skill requirement decreases the number of candidates that can be targeted. Below you can see how many more candidates could be reached if the requirements were relaxed and the skills were trained after employment.'
  },
  talents: {
    de: 'Talente',
    en: 'Talents'
  },
  talentsBodyAfter: {
    de: 'Die Talente sind bereits zur Ansprache vorbereitet. Erste Rückmeldungen sind schon ab 24 Stunden zu erwarten.',
    en: 'The talents are already prepared for outreach. First responses can be expected within 24 hours.'
  },
  perfectMatchBadge: {
    de: 'Perfect Match',
    en: 'Perfect Match'
  },
  unsureLead: {
    de: 'Noch unsicher?',
    en: 'Still unsure?'
  },
  requestAnalysisFree: {
    de: 'Analyse anfordern',
    en: 'Request analysis'
  },
  requestAnalysisPrompt: {
    de: 'Jetzt Potenzialanalyse anfordern',
    en: 'Request a potential analysis now'
  },
  requestAnalysisBody: {
    de: 'Unsere Potenzialanalyse zeigt dir datenbasiert, wie groß die Zielgruppe ist, wo passende Talente arbeiten und welche Anforderungen dich Reichweite kosten.',
    en: 'Our potential analysis shows you, based on data, how large the target group is, where matching talents work and which requirements cost you reach.'
  },
  requestAnalysisBenefits: [
    { de: 'Echte Referenzprofile', en: 'Actual reference profiles' },
    { de: 'Exakte Matches und Hidden Talents', en: 'Exact matches and hidden talents' },
    { de: 'Reichweite je Kanal', en: 'Reach per channel' },
    { de: 'Top-Arbeitgeber', en: 'Top employers' },
    { de: 'Beratung inklusive', en: 'Consultation included' }
  ],
  analysisInProgress: {
    de: 'Deine Analyse ist in Arbeit',
    en: 'Your analysis is in progress'
  },
  // the review's comment input, as the activity feed words it
  feedComment: { de: 'Kommentieren', en: 'Comment' },
  // the review's position: "Profil 2 von 5"
  reviewPagePrefix: { de: 'Profil', en: 'Profile' },
  reviewPageOf: { de: 'von', en: 'of' },
  commentRequired: {
    de: 'Bitte kommentiere, was an dem Profil nicht passt, sodass wir die Anforderungen nachschärfen können.',
    en: 'Please comment on what doesn\'t fit about this profile, so we can sharpen the requirements.'
  },
  feedCommentPlaceholder: { de: 'Kommentieren', en: 'Comment' },
  feedMentionPlaceholder: { de: '@ eingeben, um Personen zu erwähnen', en: 'Type @ to mention people' },
  startOutreach: {
    de: 'Ansprache starten',
    en: 'Start outreach'
  },
  analysisInProgressBody: {
    de: 'Wir melden uns per Benachrichtigung, sobald die Ergebnisse da sind. Du kannst die Ansprache auch schon vorher starten.',
    en: 'We will notify you as soon as the results are in. You can also start the outreach before then.'
  },
  unsureBody: {
    de: 'Unsere Analyse gibt dir datenbasierte Antworten: Wie groß ist die Zielgruppe? Welche Anforderungen schränken ein? Wie kann ich mehr Talente erreichen? Kostenfreie Beratung inklusive.',
    en: 'Our analysis gives you data-based answers: How large is the target group? Which requirements are limiting? How can I reach more talents? Free consultation included.'
  },
  requestAnalysis: {
    de: 'Analyse anfordern',
    en: 'Request analysis'
  },
  ok: {
    de: 'Ok',
    en: 'Ok'
  },
  perfectMatchesModalBody: {
    de: 'sind die Talente, die alle deine Anforderungen erfüllen und die du über Active Sourcing erreichen kannst.',
    en: 'are the talents that meet all your requirements and that you can reach through active sourcing.'
  },
  hiddenTalentsModalBody: {
    de: 'Bei der manuellen Schlagwort-Suche bei LinkedIn, XING & Co. gehen dir Talente verloren, obwohl sie deine Anforderungen erfüllen. Das KI-Kontext-Matching findet auch diese',
    en: 'With manual keyword search on LinkedIn, XING & co. you lose talents even though they meet your requirements. AI context matching finds these'
  },
  hiddenTalentsModalBodyAfter: {
    de: 'für dich.',
    en: 'for you.'
  },
  additionalPotentialModalBody: {
    de: 'gibt es weitere relevante Talente im Markt, die deine Anforderung in nur einem Aspekt nicht erfüllen.',
    en: 'there are further relevant talents in the market that fail to meet your requirements in just one aspect.'
  },
  additionalPotentialModalBodyBefore: {
    de: 'Zusätzlich zu den',
    en: 'In addition to the'
  },
  editRequirementsTitle: {
    de: 'Anforderungen bearbeiten',
    en: 'Edit requirements'
  },
  editRequirementsBody: {
    de: 'Du kannst die Anforderungen gerne bearbeiten und die Ansprache dann starten! Du wünschst vorab eine Potenzialanalyse für die geänderten Anforderungen, oder möchtest eine Beratung zum Profil? Klicke dazu nach der Bearbeitung auf "Beratung buchen".',
    en: 'Feel free to edit the requirements and then start the outreach! Would you like a potential analysis for the changed requirements first, or a consultation on the profile? After editing, click "Book consultation".'
  },
  cancel: {
    de: 'Abbrechen',
    en: 'Cancel'
  },
  referenceProfiles: {
    de: 'Referenzprofile',
    en: 'Reference profiles'
  },
  reviewTitle: {
    de: 'Feedback zu Referenzprofilen',
    en: 'Review reference profiles'
  },
  experienceTitle: {
    de: 'Berufserfahrung',
    en: 'Work experience'
  },
  educationTitle: {
    de: 'Berufsausbildung',
    en: 'Education'
  },
  noInformation: {
    de: 'Es liegen keine Angaben vor',
    en: 'No information available'
  },
  present: {
    de: 'heute',
    en: 'present'
  },
  reviewComment: {
    de: 'Dein Feedback...',
    en: 'Your feedback...'
  },
  thumbsUp: {
    de: 'Passt',
    en: 'Good fit'
  },
  thumbsDown: {
    de: 'Passt nicht',
    en: 'Not a fit'
  },
  back: {
    de: 'Zurück',
    en: 'Back'
  },
  previous: {
    de: 'Vorheriges',
    en: 'Previous'
  },
  next: {
    de: 'Nächstes',
    en: 'Next'
  },
  match: {
    de: 'Passt',
    en: 'Match'
  },
  noMatch: {
    de: 'Passt nicht',
    en: 'No Match'
  },
  reviewDone: {
    de: 'Feedback abschließen',
    en: 'Review Done'
  },
  requestNewAnalysis: {
    de: 'Neue Analyse anfordern',
    en: 'Request new analysis'
  },
  newAnalysisRequestedThankYou: {
    de: 'Vielen Dank! Wir erstellen eine neue Analyse <br> unter Berücksichtigung deines Feedbacks.',
    en: 'Thank you! We are creating a new analysis <br> that takes your feedback into account.'
  },
  newAnalysisRequested: {
    de: 'Eine neue Analyse ist angefordert. Bis sie fertig ist, siehst du hier die bisherige.',
    en: 'A new analysis has been requested. Until it is ready, you see the previous one here.'
  },
  reviewThankYou: {
    de: 'Vielen Dank für dein Feedback! Du kannst das Sourcing für die Stelle nun starten oder eine neue Analyse anfordern.',
    en: 'Thank you for your feedback! You can now start sourcing for the position or request a new analysis.'
  },
  reviewThankYouFollowUp: {
    de: 'In beiden Fällen wird dein Feedback berücksichtigt! Wenn wir Fragen haben oder dein Feedback nicht vollumfänglich umgesetzt werden kann, melden wir uns bei dir!',
    en: 'Either way, your feedback will be taken into account! If we have questions or can\'t fully implement your feedback, we\'ll get in touch with you!'
  },
  close: {
    de: 'Schließen',
    en: 'Close'
  },
  reviewTalents: {
    de: 'Ausgewählte Talente prüfen',
    en: 'Review selected talents'
  },
  reviewTalentsCta: {
    de: 'Jetzt prüfen',
    en: 'Review now'
  },
  pool: {
    de: 'Pool',
    en: 'Pool'
  },
  poolMatches: {
    de: 'passende Talente im Pool',
    en: 'matching talents in the pool'
  }
};
